export default __webpack_public_path__ + "79c1a45b6cbf23446263edc8b2807736.svg";